module.exports = __webpack_public_path__ + "static/img/tutorial-tool-competitiveness-4.82792dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-competitiveness-4.jpg
// module id = pVaX
// module chunks = 3